import { makeStyles, tokens } from '@fluentui/react-components';
export var useStyles = makeStyles({
    container: {
        width: '100vw',
        height: '100vh',
        maxWidth: '100vw',
        maxHeight: '100vh',
        padding: '0px',
        margin: '0px',
        backgroundColor: tokens.colorNeutralBackground1,
        borderRadius: tokens.borderRadiusMedium,
    },
});
//# sourceMappingURL=CopilotFre.styles.js.map